import {
    ADD_NEW_NODES,
    TOGGLE_DROPDOWN,
    TRIGGER_NEW_NODE_ACTION,
    EDIT_NODE_ACTION,
    UPDATE_NODE_ACTION,
    SET_NAME_AND_DESCRIPTION,
    DELETE_NODES,
    CREATE_NEW_RULE,
    CLEAN_UP_DATA,
    FETCH_AUTOMATION_RULES,
    TOGGLE_ACTIVE_STATUS,
    EDIT_RULE,
    CONFIRM_DELETE,
} from "../actions/automationEngineAction";
import {
    convertToRawData,
    deleteNodesAndEdges,
    formatNodesAndEdges,
    getInitialEdges,
    getInitialNodes,
    getLayoutedElements,
    updateActionEvents,
} from "../actions/automationEngineUtils";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const initialState = {
    automationName: "",
    automationDescription: "",
    nodes: getInitialNodes(),
    edges: getInitialEdges(),
    dropdownNodeReference: {},
    nodeActionEvent: {},
    editNodeActionEvents: {},
    isDirty: false,
    isLoading: false,
    automationList: [],
    editRule: false,
    confirmDeleteNode: {},
};

const automationEngineReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_NEW_NODES: {
            let { nodes: updatedNodes, edges: updatedEdges } = formatNodesAndEdges({
                nodes: state.nodes,
                edges: state.edges,
                events: action.payload,
                name: action.payload.boxName,
            });

            const { nodes, edges } = getLayoutedElements(updatedNodes, updatedEdges);
            // convertToRawData({ nodes, edges });
            return {
                ...state,
                isDirty: true,
                nodes,
                edges,
            };
        }
        case CONFIRM_DELETE:
            return {
                ...state,
                confirmDeleteNode: action.payload,
            };
        case DELETE_NODES: {
            const { nodes: updatedNodes, edges: updatedEdges } = deleteNodesAndEdges({
                nodes: JSON.parse(JSON.stringify(state.nodes)),
                edges: JSON.parse(JSON.stringify(state.edges)),
                nodeId: action.payload,
            });
            const { nodes, edges } = getLayoutedElements(updatedNodes, updatedEdges);

            return {
                ...state,
                isDirty: true,
                nodes,
                edges,
                confirmDeleteNode: {},
            };
        }
        case TOGGLE_DROPDOWN:
            return {
                ...state,
                dropdownNodeReference: action.payload || {},
            };
        case TRIGGER_NEW_NODE_ACTION:
            return {
                ...state,
                nodeActionEvent: action.payload || {},
            };

        case EDIT_NODE_ACTION:
            return {
                ...state,
                editNodeActionEvents: action.payload || {},
            };

        case UPDATE_NODE_ACTION: {
            const { nodes } = updateActionEvents({
                nodes: state.nodes,
                events: action.payload,
                name: action.payload.boxName,
            });

            return {
                ...state,
                editNodeActionEvents: {},
                nodes,
                isDirty: true,
            };
        }

        case SET_NAME_AND_DESCRIPTION:
            return {
                ...state,
                automationName: action.payload.automationName,
                automationDescription: action.payload.automationDescription,
                // isDirty: action.payload.isDirty ? true : false,
                isDirty: true,
            };
        case TOGGLE_ACTIVE_STATUS:
            return {
                ...state,
                automationList: action.payload.automationList,
            };
        case isPending(CREATE_NEW_RULE):
            return {
                ...state,
                // isDirty: false,
                isLoading: true,
            };
        case isFulfilled(CREATE_NEW_RULE):
            // return {
            //     ...state,
            //     isDirty: false,
            //     isLoading: false,
            // };
            return initialState;

        case isRejected(CREATE_NEW_RULE):
            return {
                ...state,
                isLoading: false,
            };

        case isPending(FETCH_AUTOMATION_RULES):
            return {
                ...state,
                isLoading: true,
            };
        case isRejected(FETCH_AUTOMATION_RULES):
            return {
                ...state,
                isLoading: false,
            };
        case isFulfilled(FETCH_AUTOMATION_RULES): {
            // const rules = action.payload.data.rules?.map((rule) => {
            //     const { nodes, edges } = convertRawData(JSON.parse(rule.rule_data));

            //     return { ...rule, nodes, edges };
            // });
            return {
                ...state,
                isLoading: false,
                automationList: action.payload.data.rules,
            };
        }

        case EDIT_RULE: {
            const { nodes, edges, automationName, automationDescription, ruleId } = action.payload;
            return {
                ...state,
                nodes,
                edges,
                automationName,
                automationDescription,
                editRule: ruleId,
            };
        }

        case CLEAN_UP_DATA:
            return initialState;
        default:
            return state;
    }
};

export default automationEngineReducer;
